module.exports = __webpack_public_path__ + "static/img/hgzx.e7c486c5.png";